import Home from '../pages/Home.vue';

var routes = [
  {
    path: '/',
    alias: ['/ru', '/en', '/es', '/pt'],
    transition: 'f7-fade',
    component: Home,
  },
  {
    path: '/course/:id',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const page = () => import('../pages/CourseInfo.vue');

      page().then((vc) => {
        resolve({ component: vc.default });
      });
    },
  },
  {
    path: '/dashboard/',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const page = () => import('../pages/UserDashboard.vue');

      page().then((vc) => {
        resolve({ component: vc.default });
      });
    },
  },
  {
    path: '/creators-dashboard/',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const page = () => import('../pages/CreatorsDashboard.vue');

      page().then((vc) => {
        resolve({ component: vc.default });
      });
    },
  },
  {
    path: '/lesson/:id',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const page = () => import('../pages/Lesson.vue');

      page().then((vc) => {
        resolve({ component: vc.default });
      });
    },
  },
  {
    path: '/balance/',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const popup = () => import('../pages/Balance.vue');

      popup().then((vc) => {
        resolve({ popup: { component: vc.default } });
      });
    },
  },
  {
    path: '/review/',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const popup = () => import('../components/ReviewModal.vue');

      popup().then((vc) => {
        resolve({ popup: { component: vc.default } });
      });
    },
  },
  {
    path: '/profile/',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const popup = () => import('../pages/Profile.vue');

      popup().then((vc) => {
        resolve({ popup: { component: vc.default } });
      });
    },
  },
  {
    path: '/profile-settings/',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const page = () => import('../pages/ProfileSettings.vue');

      page().then((vc) => {
        resolve({ component: vc.default });
      });
    },
  },
  {
    path: '/create-course/:id?',
    transition: 'f7-fade',
    async(_to, _from, resolve) {
      const page = () => import('../pages/CreateCourse.vue');

      page().then((vc) => {
        resolve({ component: vc.default });
      });
    },
  },
];

export default routes;
